export default __webpack_public_path__ + "static/media/stage3image.1a289e2e.png";